<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Cadastrar Mídia Social</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome:"
              v-model="state.nome"
            />
          </div>
          <div class="col-md-4">
            <label for="link">Link</label>
            <input
              id="link"
              type="text"
              class="form-control"
              placeholder="Insira um link:"
              v-model="state.link"
            />
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarMidia" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/admin/midias-sociais">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      nome: "",
      link: "",
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchMidia();
      }
    });
    async function fetchMidia() {
      try {
        const { data } = await services.midiaSocial.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome = data.nome;
        state.link = data.link;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarMidia() {
      let dados = {
        nome: state.nome,
        link: state.link,
        token,
      };
      if (!state.id) {
        try {
          await services.midiaSocial.save(dados, token);
          router.push({ name: "MidiasSociais" });
        } catch (error) {
          console.log(error);
        }
      } else {
        dados.id = state.id;
        try {
          await services.midiaSocial.update(dados, token);
          router.push({ name: "MidiasSociais" });
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      salvarMidia,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #8b0000;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #8b0000;
}
.btns_right {
  text-align: right;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
</style>